import { createFeature } from '@ngrx/store';

import { manageSurveyReducer } from './manage-survey.reducer';

export const manageSurveyFeatureKey = 'manageSurvey';

export const manageSurveyFeature = createFeature({
  name: manageSurveyFeatureKey,
  reducer: manageSurveyReducer,
});
